(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["purerdl-account-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-prdl-account-menu]';
  function close(menu, restoreFocus = false) {
    if (!menu.open) return;
    menu.open = false;
    if (restoreFocus) menu.querySelector('summary').focus();
  }
  document.addEventListener('click', event => {
    document.querySelectorAll(selector).forEach(menu => {
      if (!menu.contains(event.target)) close(menu);
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll(selector).forEach(menu => {
      if (!menu.contains(event.target)) close(menu);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest(selector);
    if (!menu || !menu.open) return;
    event.preventDefault();
    event.stopPropagation();
    close(menu, true);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["purerdl-free-shipping"] && !Shopify.designMode) return;
  try {
    (function(){
  if (!document.querySelector('[data-prdl-shipping-progress]')) return;

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function updateBar(bar, cart) {
    const threshold = Number(bar.dataset.threshold || 10000);
    const total = Number(cart.total_price || 0);
    const currency = cart.currency || bar.dataset.currency || 'EUR';
    const remaining = Math.max(0, threshold - total);
    const progress = Math.min(100, Math.max(0, (total / threshold) * 100));
    const text = bar.querySelector('[data-prdl-shipping-text]');
    const fill = bar.querySelector('[data-prdl-shipping-fill]');
    const track = bar.querySelector('[data-prdl-shipping-track]');

    if (text) {
      text.replaceChildren();
      if(total>=threshold){
        text.textContent=bar.dataset.reached;
      }else{
        const parts=bar.dataset.missingTemplate.split('__AMOUNT__');
        text.appendChild(document.createTextNode(parts[0]||''));
        if(window.PureRDLPriceDisplay)text.appendChild(window.PureRDLPriceDisplay.createMoney(remaining,true,currency));
        else text.appendChild(document.createTextNode(formatMoney(remaining,currency)));
        text.appendChild(document.createTextNode(parts.slice(1).join('__AMOUNT__')));
      }
    }
    if (fill) fill.style.width = progress + '%';
    if (track) track.setAttribute('aria-valuenow', String(Math.round(progress)));
  }

  let refreshTimer;
  async function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(async function(){
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' });
        if (!response.ok) return;
        const cart = await response.json();
        document.querySelectorAll('[data-prdl-shipping-progress]').forEach(function(bar){ updateBar(bar, cart); });
      } catch (e) {}
    }, 250);
  }

  document.addEventListener('submit', function(event){
    const form = event.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) refresh();
  }, true);

  document.addEventListener('change', function(event){
    const target = event.target;
    if (target && (target.name === 'updates[]' || target.name === 'quantity')) refresh();
  }, true);

  document.addEventListener('click', function(event){
    if (event.target.closest('cart-remove-button, [data-cart-remove], .quantity__button, [name="add"]')) refresh();
  }, true);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      if (event.cartData) {
        document.querySelectorAll('[data-prdl-shipping-progress]').forEach(function(bar){ updateBar(bar, event.cartData); });
      } else {
        refresh();
      }
    });
  }

  refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["purerdl-volume-discount"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-prdl-volume-qty]');
  if (!button) return;

  const widget = button.closest('[data-prdl-volume-discount]');
  const productInfo = widget ? widget.closest('.product__info-container') : null;
  const quantityInput = productInfo ? productInfo.querySelector('input[name="quantity"]') : document.querySelector('input[name="quantity"]');

  if (!quantityInput) return;

  quantityInput.value = button.dataset.prdlVolumeQty;
  quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  quantityInput.focus();
});
  } catch(e) { console.error(e); }
})();

})();
